import { http } from "@/utils/request.js"

// 登录
export function login(data)
{
	return http('/login','post',data.data)
}

// 图片管理分页
export function pictureList(data)
{
	return http('/pictureList','post',data)
}
// 下架图片
export function updatePictureStatus(data)
{
	console.log(data.data)
	return http('/updatePictureStatus','post',data.data)
}
// 删除图片
export function deletePicture(data)
{
	return http('/deletePicture','post',data.data)
}
// 编辑图片  &  保存图片
export function editPicture(data)
{
	return http('/editPicture','post',data.data)
}
// 编辑图片获取数据
export function selectPictureById(data)
{
	return http('/selectPictureById','post',data.data)
}

// 内容管理 - 分页
export function contentList(data)
{
	return http('/contentList','post',data)
}
// 内容管理 - 删除内容
export function deleteContent(data)
{
	return http('/deleteContent','post',data.data)
}
// 内容管理 - 下架内容
export function updateContentStatus(data)
{
	return http('/updateContentStatus','post',data.data)
}
// 内容管理 - 根据模块id 查询子模块信息
export function moduleList(data)
{
	return http('/moduleList/'+data.moduleId,'post')
}
// 内容管理 - 根据内容id查询内容信息
export function selectContentById(data)
{
	return http('/selectContentById','post',data)
}
// 内容管理 - 保存 & 编辑内容
export function editContent(data)
{
	return http('/editContent','post',data.data)
}

// 留言信息 - 分页
export function leaveList(data)
{
	return http('/leaveList','post',data)
}

// 用户管理 - 用户分页
export function searchUserPage(data)
{
	return http('/searchUserPage','post',data)
}

// 用户管理 - 用户删除
export function deleteUser(data)
{
	return http('/deleteUser','post',data.data)
}

// 用户管理 - 用户名是否存在
export function chackName(data)
{
	return http('/chackName','post',data)
}

// 用户管理 - 用户编辑
export function editUser(data)
{
	return http('/editUser','post',data)
}

// 用户管理 - 退出用户
export function exitUser(data)
{
	return http('/exitUser','post',data)
}